import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '@environments/environment';
import { ErrorInterceptor } from '@shared/core/error-interceptor';
import { JwtInterceptor } from '@shared/core/jwt-interceptor';
import { registerLicense } from '@syncfusion/ej2-base';
import LogRocket from 'logrocket';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`,
    // providers: [
    //     { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    //     { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // ]
})
export class AppComponent {
ngOnInit() {
      registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH1ccHRdRWJfV0BzWUA=');
        if (!!environment.production) {
            //this.registerLogrocket();
            LogRocket.init('gainmart/dataleed-19');
          }
        
        document.documentElement.style.fontSize = '14px';
    }

}
